export default __webpack_public_path__ + "static/media/2000-IMcover.53e92884.jpg";